import { render, staticRenderFns } from "./TheBottomArea.vue?vue&type=template&id=c9cf3ea0&scoped=true&"
import script from "./TheBottomArea.vue?vue&type=script&lang=js&"
export * from "./TheBottomArea.vue?vue&type=script&lang=js&"
import style0 from "./TheBottomArea.vue?vue&type=style&index=0&id=c9cf3ea0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9cf3ea0",
  null
  
)

export default component.exports